import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FiUpload } from 'react-icons/fi';
import { Helmet } from 'react-helmet';
import Chatbot from './Chatbot';
import KpointPlayer from './kpointplayer';
import '../css/Webpage.css';

const Webpage = ({ id, host, hostUrl }) => {
  const playerRef = useRef(null);
  const [videoInfo, setVideoInfo] = useState({ displayName: '', description: '' });
  let title='';
  useEffect(() => {
    const fetchVideoInfo = async () => {
      try {
        const response = await fetch(`https://ktpl.kpoint.com/api/v3/videos/${id}`);
        const data = await response.json();
        setVideoInfo({
          displayName: data.displayname || 'Untitled Video',
          description: data.description || 'No description available.'
        });
        title= data.displayname;
      } catch (error) {
        console.error("Error fetching video info:", error);
        // document.title = "KPOINT AI";
      }
    };

    fetchVideoInfo();
  }, [id]);

  const handlePlayerReady = useCallback((kPlayer) => {
    playerRef.current = {
      seekTo: (seconds) => {
        if (kPlayer && typeof kPlayer.seekTo === 'function') {
          kPlayer.seekTo(seconds);
        } else {
          console.error("seekTo function not available on kPlayer");
        }
      }
    };
    console.log("Player is ready", kPlayer);
  }, []);

  const onStateChange = useCallback((state) => {
    console.log("Player state changed to: ", state["data"]);
  }, []);

  return (
    <div className="webpage-container">
      <Helmet>
        <title>KPOINT.AI Video Bot</title>
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
      </Helmet>
      <div className="content-container">
        <div className="video-container">
          <div 
            style={{ width: '100%', '--pw': '3.2125px' }} 
            className="khost-loaded kplayer-loaded"
          >
            <KpointPlayer
              ref={playerRef}
              videoHost={host}
              videoId={id}
              hostUrl={hostUrl}
              videoParams={{ search: false, toc: false }}
              playerId="Player1"
              width="80%"
              onPlayerReady={handlePlayerReady}
              onStateChange={onStateChange}
            />
          </div>
          <div className="video-title-container">
            <div className="video-title">{videoInfo.displayName}</div>
            <div>
              <p className="video-description">{videoInfo.description}</p>
            </div>
          </div>
        </div>
        
          <Chatbot 
            playerRef={playerRef}
            id={id}
          />
      </div>
    </div>
  );
};

export default Webpage;